module.exports = __webpack_public_path__ + "img/phase_a.1bd506b8.svg";